import { render, staticRenderFns } from "./CampaignTasks.vue?vue&type=template&id=0f3bb660&"
import script from "./CampaignTasks.vue?vue&type=script&lang=js&"
export * from "./CampaignTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports